import { combineReducers } from 'redux'
import { combineEpics } from 'redux-observable'
import { connectRouter } from 'connected-react-router'

import conversationReducer, { epic as conversationEpic } from './conversation'
import orgReducer, { epic as orgEpic } from './org'
import userReducer, { epic as userEpic } from './user'
import profileReducer, { epic as profileEpic } from './profile'
import meetingsReducer, { epic as meetingsEpic } from './meetings'
import billingReducer, { epic as billingEpic } from './billing'
import geolocationReducer, { epic as geolocationEpic } from './geolocation'
import experimentReducer, { epic as experimentEpic } from './experiment'
import apiKeyReducer, { epic as apiKeyEpic } from './apiKey'
import { epic as authEpic } from './auth'
import { epic as metricsEpic } from './metrics'


import 'rxjs/add/observable/of'
import 'rxjs/add/observable/fromPromise'
import 'rxjs/add/observable/empty'

import 'rxjs/add/operator/pluck'
import 'rxjs/add/operator/first'
import 'rxjs/add/operator/switchMap'
import 'rxjs/add/operator/debounceTime'
import 'rxjs/add/operator/mapTo'
import 'rxjs/add/operator/do'
import 'rxjs/add/operator/ignoreElements'
import 'rxjs/add/operator/delay'

import '@driftt/dapper/lib/rx/add/retryWithBackoff'
import '@driftt/dapper/lib/rx/add/checkStatus'
import '@driftt/dapper/lib/rx/add/mapResponse'

export const rootReducer = (history) => combineReducers({
  conversation: conversationReducer,
  org: orgReducer,
  user: userReducer,
  profile: profileReducer,
  router: connectRouter(history),
  meetings: meetingsReducer,
  billing: billingReducer,
  geolocation: geolocationReducer,
  experiment: experimentReducer,
  apiKey: apiKeyReducer
})

export const rootEpic = combineEpics(
  conversationEpic,
  orgEpic,
  profileEpic,
  userEpic,
  meetingsEpic,
  billingEpic,
  geolocationEpic,
  experimentEpic,
  apiKeyEpic,
  authEpic,
  metricsEpic,
)
